/**
 * Part of dvcn project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@main';

// import '@vendor/jarallax/dist/jarallax.min.js?1bea164b822ef8320667d940';
// import '@vendor/jarallax/dist/jarallax-video.min.js?1bea164b822ef8320667d940';

// Top Banner
const bgBanner = $('.j-banner-background').owlCarousel({
  items: 1,
  autoplay: true,
  autoplayTimeout: 15000,
  loop: true,
  lazyLoad: true,
  touchDrag: false,
  mouseDrag: false,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  smartSpeed: 750,
});

const textBanner = $('.j-banner-text').owlCarousel({
  items: 1,
  dots: false,
  margin: 100,
  autoHeight: true,
  autoplay: true,
  autoplayTimeout: 15000,
  loop: true,
  lazyLoad: true,
  touchDrag: false,
  mouseDrag: false,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  smartSpeed: 750,
});

$('.c-banner .owl-dot').on('click', function () {
  bgBanner.trigger('to.owl.carousel', [$(this).index()]);
  textBanner.trigger('to.owl.carousel', [$(this).index()]);
  $('.owl-dot').removeClass('active');
  $(this).addClass('active');
});

const banners = [
  bgBanner,
  textBanner
];

banners.forEach(function (e) {
  e.on('mouseover', function () {
    banners.forEach(function (i) {
      i.trigger('stop.owl.autoplay');
    });
  });
});

banners.forEach(function (e) {
  e.on('mouseleave', function () {
    banners.forEach(function (i) {
      i.trigger('play.owl.autoplay');
    });
  });
});

// Slider
var homeSlider = $('.c-home-slider__inner');
homeSlider.owlCarousel({
  items: 1,
  autoplay: true,
  autoplayTimeout: 10000,
  rewind: true,
  lazyLoad: true,
  touchDrag: true,
  mouseDrag: true,
  margin: 15,
  responsive: {
    991: {
      items: 2,
      margin: 30,
    },
    1200: {
      items: 3,
      margin: 30,
    }
  }
});

$('.c-home-slider .c-button--next').click(function() {
  homeSlider.trigger('next.owl.carousel');
})
$('.c-home-slider .c-button--previous').click(function() {
  homeSlider.trigger('prev.owl.carousel');
})

// Wide
var bannerWide = $('.c-banner-wide__inner');
bannerWide.owlCarousel({
  items: 1,
  autoplay: true,
  autoplayTimeout: 10000,
  rewind: true,
  lazyLoad: true,
  touchDrag: true,
  mouseDrag: true,
});

$('.c-banner-wide .c-button--next').click(function() {
  bannerWide.trigger('next.owl.carousel');
})
$('.c-banner-wide .c-button--previous').click(function() {
  bannerWide.trigger('prev.owl.carousel');
})

function onYouTubeIframeAPIReady() {
  $('[data-youtube]').each((i, el) => {
    const player = new YT.Player(el, {
      videoId: el.dataset.youtube,
      // @see https://codepen.io/songyima/pen/VKbyYG
      playerVars: {
        cc_load_policy: 0, // closed caption
        controls: 0,
        disablekb: 0, //disable keyboard
        iv_load_policy: 3, // annotations
        playsinline: 1, // play inline on iOS
        rel: 0, // related videos
        showinfo: 0, // title
        modestbranding: 3 // youtube logo
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  });
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

function onPlayerReady(event) {
  event.target.mute();
  event.target.playVideo();
}

function onPlayerStateChange(event) {
  if (event.data === YT.PlayerState.PLAYING) { // loop video
    $(event.target.getIframe()).css('opacity', 1);
  }

  if (event.data === YT.PlayerState.ENDED) { // loop video
    event.target.playVideo();
  }
}

if (!u.data('china.mirror')) {
  S.import('https://www.youtube.com/iframe_api');
}
